module.exports = __webpack_public_path__ + "static/media/sideguard.5d46283b.svg";